module.exports = ".container {\n  height: calc(100% - 54px); }\n\n.messenger {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-top: 40px; }\n\n.messenger .chat {\n    width: 100%;\n    height: 74vh; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/messenger/messenger.component.scss
// module id = ./src/app/messenger/messenger.component.scss
// module chunks = main